/** Full-page loading state while auth or routes initialize. */
export function PageLoading() {
    return (
        <div className="flex min-h-screen items-center justify-center bg-background">
            <div className="text-muted-foreground">Loading…</div>
        </div>
    );
}
